const SELECTED_GARDEN_STORAGE_KEY = 'hobiBahce_selectedTesis'

const persistSelectedGarden = (garden) => {
  if (!garden) {
    return
  }

  try {
    localStorage.setItem(SELECTED_GARDEN_STORAGE_KEY, JSON.stringify(garden))
  } catch (error) {
    console.error('Seçili tesis localStorage kaydı başarısız:', error)
  }
}

const getPersistedSelectedGarden = () => {
  try {
    const storedValue = localStorage.getItem(SELECTED_GARDEN_STORAGE_KEY)
    if (!storedValue) {
      return null
    }

    return JSON.parse(storedValue)
  } catch (error) {
    console.error('Seçili tesis localStorage okuması başarısız:', error)
    return null
  }
}

const clearPersistedSelectedGarden = () => {
  try {
    localStorage.removeItem(SELECTED_GARDEN_STORAGE_KEY)
  } catch (error) {
    console.error('Seçili tesis localStorage temizliği başarısız:', error)
  }
}

// Route state yoksa localStorage'daki son seçili tesis bilgisini kullan
const resolveSelectedGarden = (routeGarden) => {
  if (routeGarden !== null && routeGarden !== undefined) {
    return routeGarden
  }

  return getPersistedSelectedGarden()
}

export {
  SELECTED_GARDEN_STORAGE_KEY,
  persistSelectedGarden,
  getPersistedSelectedGarden,
  clearPersistedSelectedGarden,
  resolveSelectedGarden,
}
